<form class="admin-filters" nz-form>
  <div class="admin-filters__actions">
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="default" type="button" (click)="downloadAllAssessmentCSV()">
          {{ "admin.assessment.download-csv-all.label" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
    <nz-form-item>
      <nz-form-control>
        <button nz-button nzType="primary" type="button" (click)="openSetupAssessmentModal()">
          {{ "admin.assessment.create.label" | translate }}
        </button>
      </nz-form-control>
    </nz-form-item>
  </div>
</form>

<ng-template #rangeTemplate let-range="range" let-total>
  {{ range[0] }}-{{ range[1] }} of {{ total }} items
</ng-template>

<div class="desktop-only">
<nz-table
  class="sticky-table" [nzScroll]="{ x: '1200px' }"
  #basicTable
  [nzData]="tableState.data?.items || []"
  nzPaginationPosition="both"
  nzShowSizeChanger="true"
  nzSize="small"
  [nzShowTotal]="rangeTemplate"
  nzFrontPagination="false"
  [nzLoading]="tableState.loading"
  [nzTotal]="tableState.data?.paging?.items || 0"
  [nzPageSize]="tableState.data?.paging?.itemsOnPage || 0"
  [nzPageIndex]="tableState.data?.paging?.page || 0"
  (nzQueryParams)="onQueryParamsChange($event)"
>
  <thead>
    <tr>
      <th>Created at</th>
      <th>Link</th>
      <th>Mission partner</th>
      <th>Status</th>
      <th>Actions</th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let data of basicTable.data">
      <td>
        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.view-details.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          [routerLink]="['/admin/assessment-view', data.id]"
        >
          {{ data.createdAt | date : "dd.MM.YYYY HH:mm" }}
        </button>
      </td>
      <td>
        <a [href]="data.link" target="_blank" class="m-r-8">link</a>
        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nz-tooltip]="data.linkCopied ? 'Copied' : 'Copy'"
          [cdkCopyToClipboard]="data.link"
          (click)="onCopyLinkClick(data)"
        >
          <span *ngIf="!data.linkCopied" nz-icon nzType="link" nzTheme="outline"></span>
          <span
            *ngIf="data.linkCopied"
            nz-icon
            nzType="check-circle"
            nzTheme="twotone"
            [twoToneColor]="'#52c41a'"
          ></span>
        </button>
      </td>
      <td>
        <a [routerLink]="['/admin/mission-partner-view', data.missionPartnerId]" target="_blank">
          {{ data.missionPartnerName }}
        </a>
      </td>
      <td>{{ data.status }}</td>
      <td>
        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.view-details.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          [routerLink]="['/admin/assessment-view', data.id]"
        >
          <span nz-icon nzType="info-circle" nzTheme="outline"></span>
        </button>
        <button
          *ngIf="data.status === MaturityAssessmentStatus.ACTIVE"
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.complete-assessment.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="confirmCompleteAssessment(data)"
        >
          <span nz-icon nzType="unlock" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="data.status !== MaturityAssessmentStatus.ACTIVE"
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.uncomplete-assessment.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="confirmUncompleteAssessment(data)"
        >
          <span nz-icon nzType="lock" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.assessment-download-csv.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="downloadAssessmentCSV(data)"
        >
          <span nz-icon nzType="file-text" nzTheme="outline"></span>
        </button>

        <button
          *ngIf="data.status !== MaturityAssessmentStatus.ACTIVE"
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.assessment-hashtags.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="editHashtags(data)"
        >
          <span nz-icon nzType="tags" nzTheme="outline"></span>
        </button>

        <input
          type="file"
          accept=""
          aria-label="File upload"
          class="assessment__file-input"
          id="fileInput"
          #fileInput
          (change)="filesSelected(fileInput.files, data)"
        />
        <button
          *ngIf="data.status !== MaturityAssessmentStatus.ACTIVE"
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.assessment-upload-report.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="fileInput.click()"
        >
          <span nz-icon nzType="upload" nzTheme="outline"></span>
        </button>

        <a
          *ngIf="data.resultFile"
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.assessment-download-report.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          [href]="data.resultFile"
          target="_blank"
        >
          <span nz-icon nzType="download" nzTheme="outline"></span>
        </a>

        <button
          *ngIf="data.resultFile"
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'admin.assessment-delete-report.tooltip' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="confirmDeleteReport(data)"
        >
          <span nz-icon nzType="file-excel" nzTheme="outline"></span>
        </button>

        <button
          nz-button
          nzType="link"
          nzSize="small"
          [nzTooltipTitle]="'delete.button' | translate"
          nzTooltipPlacement="top"
          nz-tooltip
          (click)="confirmDeleteAssessment(data)"
        >
          <span nz-icon nzType="delete" nzTheme="outline"></span>
        </button>
      </td>
    </tr>
  </tbody>
</nz-table>
</div>

<div class="mobile-only" style="margin-top: 16px;">
  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-bottom: 16px; text-align: center;"
  ></nz-pagination>

  <nz-spin [nzSpinning]="tableState.loading">
    <div style="display: flex; flex-direction: column; gap: 16px;">
      <nz-card *ngFor="let data of tableState.data?.items || []" nzHoverable nzSize="small">
        <nz-row [nzGutter]="[0, 8]">
          <nz-col [nzSpan]="24">
            <strong>Created at:</strong>
            <div>
              <button
                nz-button
                nzType="link"
                nzSize="small"
                [nzTooltipTitle]="'admin.view-details.tooltip' | translate"
                nzTooltipPlacement="top"
                nz-tooltip
                [routerLink]="['/admin/assessment-view', data.id]"
                style="padding-left: 0;"
              >
                {{ data.createdAt | date : "dd.MM.YYYY HH:mm" }}
              </button>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>Link:</strong>
            <div>
              <a [href]="data.link" target="_blank" class="m-r-8">link</a>
              <button
                nz-button
                nzType="link"
                nzSize="small"
                [nz-tooltip]="data.linkCopied ? 'Copied' : 'Copy'"
                [cdkCopyToClipboard]="data.link"
                (click)="onCopyLinkClick(data)"
              >
                <span *ngIf="!data.linkCopied" nz-icon nzType="link" nzTheme="outline"></span>
                <span *ngIf="data.linkCopied" nz-icon nzType="check-circle" nzTheme="twotone" [twoToneColor]="'#52c41a'"></span>
              </button>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>Mission partner:</strong>
            <div>
              <a [routerLink]="['/admin/mission-partner-view', data.missionPartnerId]" target="_blank">
                {{ data.missionPartnerName }}
              </a>
            </div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <strong>Status:</strong>
            <div>{{ data.status }}</div>
          </nz-col>
          <nz-col [nzSpan]="24">
            <nz-divider style="margin: 8px 0;"></nz-divider>
            <strong>Actions:</strong>
            <div style="display: flex; flex-wrap: wrap; gap: 4px; margin-top: 8px;">
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.view-details.tooltip' | translate" [routerLink]="['/admin/assessment-view', data.id]">
                <span nz-icon nzType="info-circle" nzTheme="outline"></span>
                {{ "admin.view-details.tooltip" | translate }}
              </button>
              <button *ngIf="data.status === MaturityAssessmentStatus.ACTIVE" nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.complete-assessment.tooltip' | translate" (click)="confirmCompleteAssessment(data)">
                <span nz-icon nzType="unlock" nzTheme="outline"></span>
                {{ "admin.complete-assessment.tooltip" | translate }}
              </button>
              <button *ngIf="data.status !== MaturityAssessmentStatus.ACTIVE" nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.uncomplete-assessment.tooltip' | translate" (click)="confirmUncompleteAssessment(data)">
                <span nz-icon nzType="lock" nzTheme="outline"></span>
                {{ "admin.uncomplete-assessment.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.assessment-download-csv.tooltip' | translate" (click)="downloadAssessmentCSV(data)">
                <span nz-icon nzType="file-text" nzTheme="outline"></span>
                {{ "admin.assessment-download-csv.tooltip" | translate }}
              </button>
              <button *ngIf="data.status !== MaturityAssessmentStatus.ACTIVE" nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.assessment-hashtags.tooltip' | translate" (click)="editHashtags(data)">
                <span nz-icon nzType="tags" nzTheme="outline"></span>
                {{ "admin.assessment-hashtags.tooltip" | translate }}
              </button>

              <input type="file" accept="" aria-label="File upload" class="assessment__file-input" style="display:none;" id="fileInputMobile_{{data.id}}" #fileInputMobile (change)="filesSelected(fileInputMobile.files, data)" />
              <button *ngIf="data.status !== MaturityAssessmentStatus.ACTIVE" nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.assessment-upload-report.tooltip' | translate" (click)="fileInputMobile.click()">
                <span nz-icon nzType="upload" nzTheme="outline"></span>
                {{ "admin.assessment-upload-report.tooltip" | translate }}
              </button>

              <a *ngIf="data.resultFile" nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.assessment-download-report.tooltip' | translate" [href]="data.resultFile" target="_blank">
                <span nz-icon nzType="download" nzTheme="outline"></span>
                {{ "admin.assessment-download-report.tooltip" | translate }}
              </a>
              <button *ngIf="data.resultFile" nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'admin.assessment-delete-report.tooltip' | translate" (click)="confirmDeleteReport(data)">
                <span nz-icon nzType="file-excel" nzTheme="outline"></span>
                {{ "admin.assessment-delete-report.tooltip" | translate }}
              </button>
              <button nz-button nzType="default" nzSize="small" nz-tooltip [nzTooltipTitle]="'delete.button' | translate" (click)="confirmDeleteAssessment(data)">
                <span nz-icon nzType="delete" nzTheme="outline"></span>
                {{ "delete.button" | translate }}
              </button>
            </div>
          </nz-col>
        </nz-row>
      </nz-card>
    </div>
  </nz-spin>

  <nz-pagination
    *ngIf="!tableState.loading"
    [nzPageIndex]="tableState.data?.paging?.page || 1"
    [nzTotal]="tableState.data?.paging?.items || 0"
    [nzPageSize]="tableState.data?.paging?.itemsOnPage || 10"
    (nzPageIndexChange)="onPageChange($event)"
    nzSize="small"
    [nzShowTotal]="rangeTemplate"
    style="margin-top: 16px; text-align: center;"
  ></nz-pagination>
</div>
